<template>
    <add-profile-dialog :profile-type="profileTypes.tikTok_unauthorised"
                        :enable-next-btn="enableNext"
                        :next-btn-text="nextBtnText"
                        :cur-stage="curStage"
                        :total-stages="totalStages"
                        :show-prev-btn="!saving && curStage > 1"
                        :show-next-btn="!saving"
                        @close="$emit('close')"
                        @prev="previous"
                        @next="next">
        <template #workflow>
            <keep-alive>

                <h4>Add a Tiktok Unauthorised Profile</h4>

                <TikTokUnauthorisedProfileSearch v-if="isSearchStage" />

                <edit-public-profile v-if="isEditStage"/>

                <saving-item v-if="saving" :save-complete="saveComplete" :save-error="saveError" :save-error-message="saveErrorMessage">
                    <template #additionalActions>
                        <h4 style="text-align: center; margin-top: 50px">Click <a style="cursor: pointer" @click="reset">here</a> to add more <i class="symbol-tiktok"></i> Tiktok profiles</h4>
                    </template>
                </saving-item>
            </keep-alive>
        </template>
    </add-profile-dialog>
</template>

<script>
import AddProfileDialog from "@/setup/profiles/add-profile/AddProfileDialog";
import { addProfileMixins } from "@/setup/profiles/add-profile/AddProfileMixins";
import VuexStore from "@/store/vuex/VuexStore";
import SavingItem from "@/setup/SavingItem";
import TikTokUnauthorisedProfileSearch
    from "@/setup/profiles/add-profile/tiktok-unauthorised/TikTokUnauthorisedProfileSearch.vue";
import EditPublicProfile from "@/setup/profiles/add-profile/EditPublicProfile.vue";

export default {
    name: "TikTokAddUnauthorisedProfileDialog",
    store: VuexStore,
    components: {EditPublicProfile, TikTokUnauthorisedProfileSearch, SavingItem, AddProfileDialog },
    mixins: [addProfileMixins],

    data: function () {
        return {
            curStage: 1,
            totalStages: 3
        }
    },

    created() {
        this.totalStages = Object.keys(this.addProfileStages.tiktok.public).length;
    },

    computed: {
        isSearchStage() {
            return !this.saving && this.curStage === this.addProfileStages.tiktok.public.SEARCH_PAGE
        },


        isEditStage() {
            return !this.saving && this.curStage === this.addProfileStages.tiktok.public.EDIT_PAGE
        },

        enableNext() {
            // return !!this.newProfileData.managedProfiles.profiles?.length;

            // If we are on the edit stage, we only allow saving if the profile has a category set
            if (this.curStage === this.addProfileStages.tiktok.public.EDIT_PAGE) {
                return !!this.newProfileData.publicProfile?.media
            }

            // If we are on the search stage, we only enable next if the profile is not currently in the account (check "existing" field)
            if (this.curStage === this.addProfileStages.tiktok.public.SEARCH_PAGE) {
                return !this.newProfileData.publicProfile?.existing && !!this.newProfileData.publicProfile;
            }

            return false;
        },

        nextBtnText() {
            // if we are on the final stage, show "Save" instead of "Next"
            return this.curStage === this.totalStages - 1 ? "Save" : "Next";
        }
    },

    methods: {
        next() {
            this.curStage++;
            if (this.curStage === this.totalStages)  this.savePublicProfile(this.profileTypes.tikTok_unauthorised);
        },

        previous() {
            this.curStage--;

            if (this.curStage === 0) {
                this.curStage = 1;
            }
        },

        reset() {
            this.saving = false;
            this.saveComplete = false;
            this.curStage = 1;
            this.clearNewProfiles();
        }
    }
}
</script>

<style scoped>

.continue /deep/ .btn {
    padding: 2px;
}

.error {
    color: var(--colour-error);
}

</style>